import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "The award-winning eGeeTouch® smart electronic lock is deliberately created to be EASE-OF-USE, SECURED yet AFFORDABLE to users and when adopted enables our business partners to clearly differentiate from their existing luggage assembled with old fashioned digit-wheel combination locks, and transform them into smart-locks driven new luggage that is relevant to our modern mobile society.",
    reply2:
      "The adoption of eGeeTouch® smart lock technology driven luggage, effectively empowers our business partners and OEM customers to design new product lines (i.e. new luggage) with unique selling point (i.e. with smart locks) completely differentiated from their competitors (i.e. mostly still focusing on lightweight & durability) thus strengthen their product portfolio to grow in the competitive global luggage industry.",
    back: "Back",
  },
  ja: {
    reply1:
      "受賞歴のある eGeeTouch® スマート電子ロックは、使いやすく、安全でありながらユーザーにとって手頃な価格であるように意図的に作成されており、採用すると、当社のビジネス パートナーは、昔ながらの数字ホイール コンビネーション ロックで組み立てられた既存の荷物と明確に区​​別できるようになります。それらを現代のモバイル社会に適したスマートロック駆動の新しい鞄に変えます。",
    reply2:
      "eGeeTouch® スマート ロック テクノロジーを活用したスーツケースの採用により、当社のビジネス パートナーや OEM 顧客は、競合他社と完全に差別化された独自のセールス ポイント (つまり、スマート ロックを備えた) を備えた新しい製品ライン (つまり、新しいスーツケース) を設計できるようになります (つまり、主に依然として重点を置いているのは、軽量性と耐久性）により、競争の激しい世界的な旅行かばん業界で成長するために製品ポートフォリオを強化します。",
    back: "戻る",
  },
  es: {
    reply1:
      "La galardonada candado electrónica inteligente eGeeTouch® se creó deliberadamente para ser FACIL DE USAR, SEGURA pero ASEQUIBLE para los usuarios y, cuando se adopta, permite a nuestros socios comerciales diferenciarse claramente de su equipaje existente ensamblado con candados de combinación de ruedas digitales antiguas, y transfórmalos en equipaje nuevo impulsado por candados inteligentes que sea relevante para nuestra sociedad móvil moderna.",
    reply2:
      "La adopción del equipaje impulsado por la tecnología de candado inteligente eGeeTouch® permite de manera efectiva a nuestros socios comerciales y clientes OEM diseñar nuevas líneas de productos (es decir, equipaje nuevo) con un punto de venta único (es decir, con candados inteligentes) completamente diferenciadas de sus competidores (es decir, en su mayoría todavía centrándose en peso ligero y durabilidad) fortalecen así su cartera de productos para crecer en la competitiva industria mundial del equipaje.",
    back: "Atrás",
  },
});

class Q27_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q27_component;
